angular.module('mercury.modules.stock.unit', [

]);
